import { Route } from '@angular/router';
import { inject } from '@angular/core';
import { RouteIds } from '../../../types';
import { ConfirmationStepComponent } from './confirmation-step.component';
import { StepResolverService } from '../../../services';

export const confirmationStepRoute: Route = {
  path: RouteIds.confirmation,
  resolve: { step: () => inject(StepResolverService).resolve(RouteIds.confirmation) },
  component: ConfirmationStepComponent,
};
